import columns from '../../../react-table/helpers/columns';

export default (data) => {
  const {
    FilteredTextColumn,
    FilteredDateTimeColumn,
  } = columns(data);

  return [
    {
      Header: '',
      columns: [
        new FilteredTextColumn('RFID ID', 'rfid'),
        new FilteredDateTimeColumn('Exit Day (UTC)', 'exitDay'),
        new FilteredDateTimeColumn('Entry Day (UTC)', 'entryDay'),
        new FilteredTextColumn('Part', 'part'),
        new FilteredTextColumn('Outbound operator', 'outboundOperator'),
        new FilteredTextColumn('Outbound IMPC', 'outboundImpc'),
        new FilteredTextColumn('Inbound operator', 'inboundOperator'),
        new FilteredTextColumn('Inbound IMPC', 'inboundImpc'),
        new FilteredTextColumn('Trip', 'trip'),
      ],
    },
  ];
};
